import { gtagID } from "../env";
import { startsWith } from "lodash";

type GTag = (key: string, trackingId: string, config: object) => void;

type PageViewRequest = (pathName?: string, pageTitle?: string) => void;
type EventRequest = (eventName: string, data?: object) => void;

declare global {
  interface Window {
    gtag?: GTag;
  }
}

function useGTag(): GTag | null {
  if (!window.gtag) return null;
  if (!gtagID) {
    console.log(
      "Tracking not enabled, as `trackingId` was not given and there is no `GTAG_ID`."
    );
    return null;
  }
  return window.gtag;
}

function useGTagPageView(): PageViewRequest {
  const gtag = useGTag();
  if (!gtag) return () => {};

  return (pathName?: string, pageTitle?: string) => {
    if (pathName && !startsWith(pathName, "/")) {
      console.log(
        `Logging a page view with path name "${pathName}" that doesn't start with '/' - value will be ignored`
      );
    }
    gtag("config", gtagID, {
      page_path: pathName,
      page_title: pageTitle,
    });
  };
}

function useGTagEvent(): EventRequest {
  const gtag = useGTag();
  if (!gtag) return () => {};

  return (eventName: string, data?: { [key: string]: any }) => {
    gtag("event", eventName, { ...data });
  };
}

export { useGTagPageView, useGTagEvent };
